/** Full-screen holding page for users whose join request is pending/rejected. */
import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { Loader2, Hourglass, XCircle, LogOut, RefreshCw } from "lucide-react";

export const PendingJoinScreen = () => {
  const { user, refresh, logout } = useAuth();
  const [checking, setChecking] = useState(false);
  const rejected = user.pending_join_status === "rejected";

  const check = async () => {
    setChecking(true);
    await refresh();
    setChecking(false);
  };

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center px-4" data-testid="pending-join-screen">
      <div className="w-full max-w-md bg-white border-2 border-slate-900 shadow-xl p-8 text-center space-y-4">
        {rejected ? <XCircle size={44} className="mx-auto text-red-500"/> : <Hourglass size={44} className="mx-auto text-amber-500"/>}
        <h1 className="text-2xl font-black text-slate-900">
          {rejected ? "Access request declined" : "Awaiting approval"}
        </h1>
        <p className="text-sm text-slate-600 leading-relaxed">
          {rejected
            ? <>Your request to join <strong>{user.pending_org_name}</strong> was declined. If you believe this is a mistake, contact your organisation administrator or Compliance Hub support.</>
            : <>Your request to join <strong>{user.pending_org_name}</strong> has been sent to the organisation owner. You'll receive an email as soon as it's approved.</>}
        </p>
        <div className="flex flex-col gap-2 pt-2">
          {!rejected && (
            <button onClick={check} disabled={checking} data-testid="pending-join-refresh"
              className="h-12 bg-[#1E1B4B] text-white font-bold text-sm hover:bg-[#0F0E2E] disabled:opacity-60 inline-flex items-center justify-center gap-2">
              {checking ? <Loader2 size={15} className="animate-spin"/> : <RefreshCw size={15}/>}Check approval status
            </button>
          )}
          <button onClick={logout} data-testid="pending-join-logout"
            className="h-12 border-2 border-slate-300 font-bold text-sm text-slate-700 hover:bg-slate-50 inline-flex items-center justify-center gap-2">
            <LogOut size={15}/>Sign out
          </button>
        </div>
      </div>
    </div>
  );
};
